export enum DataLegitimacy {
  LEGITIMATE = 'LEGITIMATE',
  ARTIFICIAL = 'ARTIFICIAL',
}
